import { action } from 'typesafe-actions';

const entity = 'layout';
const ACTION_TOGGLE = `${entity}/TOGGLE`;
const ACTION_CLOSE_INFO = `${entity}/CLOSE_INFO`;
const ACTION_OPEN_INFO = `${entity}/OPEN_INFO`;
const ACTION_CLOSE_TRADING = `${entity}/CLOSE_TRADING`;
const ACTION_OPEN_TRADING = `${entity}/OPEN_TRADING`;
const ACTION_CLOSE_TRADES = `${entity}/CLOSE_TRADES`;
const ACTION_OPEN_TRADES = `${entity}/OPEN_TRADES`;

const actionToggleWidget = (field: string, value: boolean) =>
  action(ACTION_TOGGLE, { field, value });

const actionCloseInfo = () => action(ACTION_CLOSE_INFO);

const actionOpenInfo = () => action(ACTION_OPEN_INFO);

const actionCloseTrading = () => action(ACTION_CLOSE_TRADING);

const actionOpenTrading = () => action(ACTION_OPEN_TRADING);

const actionCloseTrades = () => action(ACTION_CLOSE_TRADES);

const actionOpenTrades = () => action(ACTION_OPEN_TRADES);

export {
  ACTION_TOGGLE,
  ACTION_CLOSE_INFO,
  ACTION_OPEN_INFO,
  ACTION_CLOSE_TRADING,
  ACTION_OPEN_TRADING,
  ACTION_CLOSE_TRADES,
  ACTION_OPEN_TRADES,
  actionToggleWidget,
  actionCloseInfo,
  actionOpenInfo,
  actionCloseTrading,
  actionOpenTrading,
  actionCloseTrades,
  actionOpenTrades,
};
